import { Component, Input, Output, EventEmitter, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { RolesService } from '@/apiConnection/roles.service';
import { Utils } from '@/utils/utils';
import { LoadingComponent } from '@/components/loading/loading.component';

@Component({
  selector: 'app-role-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    LoadingComponent,
  ],
  templateUrl: './role-form.component.html',
})
export class RoleFormComponent implements OnInit {
  @Input() id = 0;
  @Input() role: any = null;
  @Output() closeFunction = new EventEmitter<void>();
  @Output() acceptFunction = new EventEmitter<any>();

  loading = signal(false);
  saving = signal(false);

  form = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.maxLength(255)]),
    description: new FormControl(''),
  });

  constructor(private rolesService: RolesService) {}

  ngOnInit() {
    if (this.role) {
      this.form.patchValue({ name: this.role.name, description: this.role.description });
    }
  }

  save() {
    if (this.form.invalid) {
      Utils.notification.alert('El nombre del rol es obligatorio');
      return;
    }
    this.saving.set(true);
    const data = this.form.value as { name: string; description?: string };
    const req = this.id
      ? this.rolesService.updateRole(this.id, data)
      : this.rolesService.createRole(data);

    req.subscribe({
      next: (res) => {
        Utils.notification.success(this.id ? 'Rol actualizado' : 'Rol creado');
        this.acceptFunction.emit(res);
        this.closeFunction.emit();
      },
      error: (error: any) => {
        this.saving.set(false);
        Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al guardar el rol');
      },
      complete: () => (this.saving.set(false)),
    });
  }
}
